import { createSharedComposable } from "@vueuse/core";

export const OPEN_LOY_JOY_HASH = "#openLoyJoy";

const openLoyJoyOnHashChange = function () {
  const checkLoyJoyHash = (e) => {
    if (e?.target?.href?.includes?.(OPEN_LOY_JOY_HASH)) {
      try {
        e.stopPropagation();
        e.preventDefault();
        globalThis.LoyJoy("open");
      } catch (err) {
        console.error(err);
      }
      // reset hash to make reopen possible
      location.hash = "";
    }
  };

  onMounted(() => {
    // watch changes
    globalThis.document.addEventListener("click", checkLoyJoyHash);
  });

  onUnmounted(() => {
    // cleanup
    globalThis.document.removeEventListener("click", checkLoyJoyHash);
  });
};

export const useLoyJoy = createSharedComposable(openLoyJoyOnHashChange);
